import React from 'react';
// Constants
import {
  ContactEmailAddress,
} from '../../utils/Constants';
import {
  QUESTIONNAIRE_PAGE_URL,
} from '../../utils/Routes';
import { Link } from 'react-router-dom';

function ContactCard() {
  return (
    <section className='grid gap-1 bg-colour6 shadow-cardShadow lg:text-center w-full lg:w-fit mx-auto px-6 md:px-8 lg:px-16 py-2 lg:py-4'>
      <p className='text-sm lg:text-lg'>
        <strong>Email:</strong>{' '}
        <a
          href={`mailto:${ContactEmailAddress}`}
          className='text-colour1 hover:underline'
        >
          {ContactEmailAddress}
        </a>
      </p>
      <div className='text-sm lg:text-lg'>
        <strong>Application:</strong>{' '}
        <Link
          to={QUESTIONNAIRE_PAGE_URL}
          className='text-colour1 hover:underline'
          title='Complete submission questionaire'
          aria-label='Complete submission questionaire'
        >
          Submission Form
        </Link>
      </div>
    </section>
  );
}

export default ContactCard;
